import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  CircularProgress,
  Button,
  TextField,
  Autocomplete,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Alert,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch, useSelector } from "react-redux";
import {
  getCategoryVariantValue,
  addCategoryVariantValue,
  deleteCategoryVariantValue,
} from "../../../../redux/actions/categorysActions";
import { fetchcategoryAttribute } from "../../../../redux/actions/outWard";
import { fetchAttributeAction } from "../../../../redux/actions/attributeAction";
import marketplacesService from "../../../../services/marketplacesService";
import ecommercePlaceService from "../../../../services/ecommercePlaceService";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "80%", md: "600px" },
  maxWidth: "600px",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: { xs: 2, md: 3 },
  maxHeight: "90vh",
  overflowY: "auto",
};

// placeCategoryVariant: CategoryVariant.jsx listesindeki satır - id, categoryId,
// marketPlaceId/ecommercePlaceId, marketPlaceName, pcVariantName, variantId(pazaryeri attribute id)
const AddCategoryVariantValue = ({ open, handleClose, placeCategoryVariant }) => {
  const [loading, setLoading] = useState(true);
  const [pcVariantValueName, setPcVariantValueName] = useState("");
  const [selectedMarketplaceValue, setSelectedMarketplaceValue] = useState(null);
  const [saving, setSaving] = useState(false);

  const userId = useSelector((state) => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  // Swal.fire (useAlert) ayrı bir overlay/portal açtığı için MUI Modal'ın arka planıyla
  // çakışıp modalı kapanmış gösteriyordu; bu yüzden burada modal içinde kalan basit bir
  // inline mesaj kullanılıyor.
  const [feedback, setFeedback] = useState(null); // { type: 'success' | 'error', text: string }

  const dispatch = useDispatch();

  const values = useSelector((state) => state?.categoryVariantValue?.categoryVariantValue) ?? [];
  const categoryAttributeState = useSelector((state) => state?.outWardCategoryAttribute) ?? { outWardCategoryAttribute: [] };
  // GetGroupByValue (isGroupValue=true) - artık AttributeValue tablosundan gerçek değerler geliyor,
  // "Varyant Ara" (AddCategoryVariant.jsx) ile aynı karışık isim listesi değil
  const attributeState = useSelector((state) => state?.attributes);
  const ourValues = attributeState?.attributes ?? [];

  const matchedAttribute = categoryAttributeState.outWardCategoryAttribute?.find(
    (item) => item?.attribute?.id === placeCategoryVariant?.variantId
  );
  const marketplaceValues = matchedAttribute?.attributeValues ?? [];

  const loadValues = async () => {
    if (!placeCategoryVariant?.id) return;
    setLoading(true);
    try {
      await dispatch(getCategoryVariantValue(placeCategoryVariant.id, token));
    } finally {
      setLoading(false);
    }
  };

  const loadMarketplaceAttributeValues = async () => {
    if (!placeCategoryVariant) return;
    try {
      const marketAccounts = await marketplacesService.getMarketPlacesAccountsApi(userId, token);
      const ecommerceAccounts = await ecommercePlaceService.getEcommercePlaceAccountsApi(userId, token);

      const marketPlaceSettings = (marketAccounts?.data?.data?.data ?? [])
        .filter((account) => account.marketPlaceName === placeCategoryVariant.marketPlaceName)
        .map((account) => ({
          id: 0,
          userId: account.userId,
          marketPlaceId: account.marketPlaceId || 0,
          marketPlaceName: account.marketPlaceName,
          valueId: account.valueId,
          value: account.value,
          createDate: new Date().toISOString(),
          updateDate: new Date().toISOString(),
          ia: true,
        }));

      const ecommercePlaceSettings = (ecommerceAccounts?.data?.data?.data ?? [])
        .filter((account) => account.ecommercePlaceName === placeCategoryVariant.marketPlaceName)
        .map((account) => ({
          id: 0,
          userId: account.userId,
          ecommercePlaceId: account.ecommercePlaceId || 0,
          ecommercePlaceName: account.ecommercePlaceName,
          valueId: account.valueId,
          value: account.value,
          createDate: new Date().toISOString(),
          updateDate: new Date().toISOString(),
          ia: true,
        }));

      // placeCategoryVariant.categoryId BİZİM kategori id'miz, Etsy/Trendyol vb. kendi kategori
      // özelliklerini bu id ile çekemez; ilgili pazaryerine ait MarketPlaceCategoryId (string) kategori
      // eşleştirmesinden (PlaceCategories) geliyor.
      const placeCategory = placeCategoryVariant.category?.placeCategories?.find(
        (pc) => pc.marketPlaceName === placeCategoryVariant.marketPlaceName
          || pc.ecommercePlaceName === placeCategoryVariant.marketPlaceName
      );

      if (!placeCategory?.marketPlaceCategoryId) {
        console.error(
          "Bu varyant eşleştirmesinin kategorisi için pazaryeri kategori eşleştirmesi bulunamadı."
        );
        return;
      }

      const requestBody = {
        categoriId: placeCategory?.marketPlaceCategoryId ?? "",
        userId: userId,
        marketPlaceSetting: marketPlaceSettings,
        EcommercePlaceSettings: ecommercePlaceSettings,
        startDate: new Date().toISOString(),
        endDate: new Date().toISOString(),
        page: 0,
        size: 100,
      };

      await dispatch(fetchcategoryAttribute(placeCategoryVariant.marketPlaceName, requestBody, token));
    } catch (error) {
      console.error("Pazaryeri özellik değerleri alınırken hata oluştu:", error);
    }
  };

  useEffect(() => {
    if (open) {
      loadValues();
      loadMarketplaceAttributeValues();
      dispatch(fetchAttributeAction(userId, token, false, true)); // artık gerçek attribute değerleri
      setPcVariantValueName("");
      setSelectedMarketplaceValue(null);
      setFeedback(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, placeCategoryVariant?.id]);

  const handleSave = async () => {
    if (!pcVariantValueName || !selectedMarketplaceValue) return;

    setSaving(true);
    const data = {
      PlaceCategoryVariantId: placeCategoryVariant.id,
      PcVariantValueName: pcVariantValueName,
      VariantValueId: selectedMarketplaceValue.id,
      VariantValueName: selectedMarketplaceValue.name,
      CreateDate: new Date().toISOString(),
      UpdateDate: new Date().toISOString(),
      Ia: true,
      UserId: userId,
    };

    try {
      await dispatch(addCategoryVariantValue(data, token));
      setFeedback({ type: "success", text: "Eşleşme eklendi." });
      setPcVariantValueName("");
      setSelectedMarketplaceValue(null);
      await loadValues();
    } catch {
      setFeedback({ type: "error", text: "Eşleşme eklenirken hata oluştu, tekrar deneyiniz." });
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await dispatch(deleteCategoryVariantValue(id, token));
      setFeedback({ type: "success", text: "Eşleşme silindi." });
      await loadValues();
    } catch {
      setFeedback({ type: "error", text: "Eşleşme silinirken hata oluştu, tekrar deneyiniz." });
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Varyant Değerlerini Eşleştir
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, color: "text.secondary" }}>
          {placeCategoryVariant?.pcVariantName} ({placeCategoryVariant?.marketPlaceName} -{" "}
          {placeCategoryVariant?.variantName})
        </Typography>

        {feedback && (
          <Alert severity={feedback.type} sx={{ mb: 2 }} onClose={() => setFeedback(null)}>
            {feedback.text}
          </Alert>
        )}

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 2 }}>
              <Autocomplete
                size="small"
                options={ourValues}
                getOptionLabel={(option) => option ?? ""}
                value={pcVariantValueName || null}
                onChange={(event, value) => setPcVariantValueName(value ?? "")}
                renderInput={(params) => (
                  <TextField {...params} label="Bizim Değerimiz" variant="outlined" />
                )}
                fullWidth
              />

              <Autocomplete
                size="small"
                options={marketplaceValues}
                getOptionLabel={(option) => option?.name ?? ""}
                isOptionEqualToValue={(a, b) => a?.id === b?.id}
                value={selectedMarketplaceValue}
                onChange={(event, value) => setSelectedMarketplaceValue(value)}
                renderInput={(params) => (
                  <TextField {...params} label="Pazaryeri Değeri" variant="outlined" />
                )}
                fullWidth
              />

              <Button
                variant="contained"
                onClick={handleSave}
                disabled={saving || !pcVariantValueName || !selectedMarketplaceValue}
                sx={{ borderRadius: 2 }}
              >
                Eşleşmeyi Ekle
              </Button>
            </Box>

            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Bizim Değerimiz</TableCell>
                  <TableCell>Pazaryeri Değeri</TableCell>
                  <TableCell align="right">İşlemler</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {values.length > 0 ? (
                  values.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{item.pcVariantValueName}</TableCell>
                      <TableCell>{item.variantValueName}</TableCell>
                      <TableCell align="right">
                        <IconButton size="small" onClick={() => handleDelete(item.id)}>
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      Henüz değer eşleşmesi yok
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default AddCategoryVariantValue;
